import React, { ReactNode } from 'react';
import { PoweredByVera } from 'components/UI';

// TODO(VRG-173): promote to categorized app component library / @repo/ui once
// apps/app gets its own component library (VERA-837 build-decision note).

interface OnboardingShellProps {
  heading: string;
  subheading?: string;
  children: ReactNode;
}

/**
 * Shared outer card layout for the onboarding email landing pages (VERA-843
 * Account Email Path, VERA-839 Claim-Ownership Sign-Up). Mirrors the
 * `SignInBanner` (apps/app/src/pages/SignIn/SignInBanner.tsx) centered-card
 * layout so a user following an invite link lands on a visually-consistent
 * surface with the rest of the auth flow.
 */
export const OnboardingShell = ({ heading, subheading, children }: OnboardingShellProps) => (
  <div className='flex flex-col items-center pt-[20vh] pb-8 px-4 bg-background min-h-screen w-full'>
    <div className='w-full max-w-[400px]'>
      <h2 className='mb-3 text-[24px] leading-[32px] font-[400]'>{heading}</h2>
      {subheading && (
        <p className='mb-6 text-[14px] leading-[20px] font-[400] text-gray-500'>{subheading}</p>
      )}
      <div className='mt-6'>{children}</div>
    </div>
    {/*
      VRG-500 — the attribution belongs HERE, not at the three call sites.

      `ClaimOwnershipSignUp` renders this shell from three different branches (signed
      out, signed in as the recipient, identity still resolving), and the user reported
      the footer missing from the sign-in one specifically. Adding it per branch would
      have fixed that one and left the same gap in the other two — the shell is the only
      place all three pass through (§36: the second hand-roll is a shared component).

      The unusable-link state does NOT come through here — it is its own layout and
      renders `PoweredByVera` itself, with a note explaining why it cannot honour the
      white-label entitlement (no certificate id to read `hide_powered_by` from).

      `mt-auto` rather than a fixed margin: the wrapper is `min-h-screen`, so on a short
      claim screen this sits at the bottom of the viewport and on a long one it follows
      the content instead of overlapping it.
    */}
    <div className='mt-auto pt-10'>
      <PoweredByVera />
    </div>
  </div>
);
